import React from "react"
import { useAppContext } from "../../providers/AppProvider"

export function ErrorBanner() {
  const { error, clearError } = useAppContext()

  if (!error) return null

  return (
    <div
      className="alert alert-danger alert-dismissible fade show"
      role="alert"
      style={{
        position: "relative",
        top: 80,
        left: 0,
        right: 0,
        zIndex: 1050,
        margin: 0,
        borderRadius: 0,
      }}>
      <strong>Error:</strong> {error}
      <a
        href="javascript:void(0)"
        type="button"
        className="close-mobile-menu d-block mobileMenuCss font-weight-bold"
        aria-label="Close"
        onClick={clearError}
        style={{ float: "right" }}>
        x
      </a>
    </div>
  )
}
